<template>
<div class='page-start'>
	<mdb-container class="pb-3" fluid>

    <!-- User Feedback and Error Code Displays -->

    <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p1" @closeAlert="p1=false" dismiss>
        Success! Updated Support Ticket!
    </mdb-alert>
    <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2" @closeAlert="p2=false" dismiss>
        There was an error submitting Support Ticket. Please try again! Error Code P2
    </mdb-alert>
    <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p3" @closeAlert="p3=false" dismiss>
        There was an error populating ticket data. Please try again! Error Code P3
    </mdb-alert>
    <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p4" @closeAlert="p4=false" dismiss>
        There was an error populating "Assigned To" dropdown. Please try again! Error Code P4
    </mdb-alert>
    <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p5" @closeAlert="p5=false" dismiss>
        There was an error fetching ticket data. Please try again! Error Code P5
    </mdb-alert>
    <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p7" @closeAlert="p7=false" dismiss>
        Success! A new ITCR has been created!
    </mdb-alert>
    c

    <!-- END User Feedback and Error Code Displays -->


    <mdb-modal :show="priorityModal" @close="priorityModal = false" centered>
      <mdb-modal-header>
        <mdb-modal-title>About Priority levels</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="text-left">
        <ol>
          <li><u>High:</u> Needs to be done ASAP</li>
          <li><u>Above Average:</u> Needs to be done at the next available time slot</li>
          <li><u>Medium:</u> Needs to be done when there is some free time</li>
          <li><u>Below Average:</u> Needs to be done when it is not busy</li>
          <li><u>Low:</u> Does not need to be done soon</li>
        </ol>
      </mdb-modal-body>
      <mdb-modal-footer class="d-flex justify-content-center">
        <mdb-btn color="secondary" @click.native="priorityModal = false">Close</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>


    
    <mdb-card class="mb-3 d-flex">
    <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">Unassigned Support Tickets</h3>
    <mdb-card-body>


      <mdb-btn class="QuadrusButton" v-on:click="viewReport = true">Generate Report</mdb-btn>
      <mdb-modal size="xl" centered :show="viewReport" @close="viewReport = false" style="z-index: 9999 !important;">
          <mdb-modal-header>
            <mdb-modal-title><p class="h2 grey-text">Generate Report</p></mdb-modal-title>
          </mdb-modal-header>
          <mdb-modal-body style="font-size: 0.9em;">  
            <mdb-row>
                <mdb-col>
                  <h5 class="card-title font-weight-bold text-uppercase mt-2">Filter By Ticket Status</h5>
                  <mdb-input class="mb-0 mt-2" type="checkbox" id="unassignedSort" v-model="unassignedSort" name="unassignedSort" label="Show Unassigned Tickets" @click.native.prevent="handleToggle('unassigned')"/>
                  <mdb-input class="mb-0 mt-2" type="checkbox" id="assignedSort" v-model="assignedSort" name="assignedSort" label="Show Assigned Tickets" @click.native.prevent="handleToggle('assigned')"/>
                  <mdb-input class="mb-0 mt-2" type="checkbox" id="resolvedSort" v-model="resolvedSort" name="resolvedSort" label="Show Resolved Tickets" @click.native.prevent="handleToggle('resolved')"/>
                </mdb-col>
                <mdb-col>
                  <h5 class="card-title font-weight-bold text-uppercase mt-2">Date (Optional)</h5>
                  <p>By default, all data will be included. If you want a specific month or year, use this option </p>
                  <hr>
                  <mdb-select label="Month" @getValue="setScopeMonth" v-model="monthOptions" required />
                  <mdb-input type="number" label="Year" v-model="scopeYear" :min="2021" />
              </mdb-col>
            </mdb-row>
          </mdb-modal-body>

          <mdb-modal-footer class="d-flex justify-content-between">
            <mdb-btn color="secondary" @click.native="viewReport = false, scopeMonth = 0, scopeYear = 0">Close</mdb-btn>
            <download-csv
              class="btn QuadrusButton"
              :data="exportData"
              name="supportTicketReport.csv">
              Generate Report
            </download-csv>
          </mdb-modal-footer>
      </mdb-modal>

      
        <QDataTable id='unassignedTable' :rowData="this.ticketData.unassigned.rowData" :filterWords="this.ticketData.unassigned.filterWords" :headers="this.ticketData.unassigned.columns" 
        :btnName="'Manage'" :hasBtn="true" @use-method='manageUnassignedTicket' :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}">
        </QDataTable>
        <div :class="{'hideSpinner': isSetUp}" class="p-4">
          <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
        </div>
    </mdb-card-body>
    </mdb-card>
  

    <!-- Create Ticket Table -->
    <mdb-card class="mb-3 d-flex" id="ticketForm" ref="ticketForm" style="scroll-margin-top: 11vh;">
    <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4"> Manage Support Ticket</h3>
    <mdb-card-body>
      <form class="was-validated" >
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="reqTicketFields" @closeAlert="reqTicketFields=false" dismiss>
          Missing Required Fields
        </mdb-alert>
        <mdb-row>
          <mdb-col>
            <mdb-input label="Name of Submitter" v-model="nameSubmit" disabled/>
          </mdb-col>
          <mdb-col>
            <mdb-input label="Email of Submitter" v-model="emailSubmit" disabled/>
          </mdb-col>
          <mdb-col>
            <mdb-input label="Issue" v-model="issue" disabled/>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col class="col-8">
            <mdb-input label="Description" v-model="description" type='textarea' :rows="4" outline readOnly />
          </mdb-col>
          <mdb-col class="col-4">
            <mdb-row class="d-flex align-items-center justify-content-center">
              <mdb-btn :disabled="!ticketHasImage" v-on:click="viewImages">View Images</mdb-btn>
            </mdb-row>
            <mdb-row class="d-flex align-items-center justify-content-center">
              <mdb-btn :disabled="!ticketHasDocs" v-on:click="viewDocuments">View Documents</mdb-btn>
            </mdb-row>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col> 
            <mdb-select v-model="subjectOptions" label="Subject" :placeholder="subject" @getValue="setSubject" required 
            :disabled="manageTicketID == '' || resolvedSubmit" maxlength="20"/>
          </mdb-col>
           <mdb-col>
            <mdb-input v-if="resolvedSubmit" label="Assigned To" v-model="userAssignedName" disabled/>
            <mdb-select v-else v-model="assignToOptions" label="Assigned To" @getValue="setAssignTo" :disabled="manageTicketID == '' || resolvedSubmit" />
          </mdb-col>
          <mdb-col>
            <p class="h5 mb-n4">Priority <mdb-icon icon="question-circle" size="sm" class="indigo-text" style="cursor: pointer;" @click.native="priorityModal = true" /></p>
            <mdb-input type="number" v-model="priority" :max='5' :min='1' required invalid-feedback="Please Input Priority" 
            valid-feedback="Looks Good!" :disabled="manageTicketID == '' || resolvedSubmit" />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <mdb-input v-model="dateOpenedDisplay" label='Date Opened' id="dateOpened" title='Date Opened' disabled />
          </mdb-col>
          <mdb-col>
            <mdb-date-picker-2 v-model="dateClosedDisplay" label='Date Closed' id="dateClosed" title='Date Closed' disabled/>
          </mdb-col>
          <mdb-col>
            <p class="h5">Resolved: </p>
            <mdb-form-inline class="justify-content-center" novalidate >
              <mdb-input @change="setDate" type="radio" id="resolvedFalse" name="resolved" radioValue="false" v-model="resolved" label="No" 
              checked required :disabled="manageTicketID == '' || resolvedSubmit"/>
              <mdb-input @change="setDate" type="radio" id="resolvedTrue" name="resolved" radioValue="true" v-model="resolved" label="Yes"  
              required :disabled="manageTicketID == '' || resolvedSubmit"/>
            </mdb-form-inline>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <mdb-input label="Additional Notes" v-model="additionalNotes" :readOnly="manageTicketID == '' || resolvedSubmit" 
            type='textarea' :rows="8" outline maxlength="5000" class="textarea-scroll"/>
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col>
            <mdb-input type='textarea' :rows="3" outline label="Solution *" v-model="solution" 
              :readOnly="manageTicketID == '' || resolved == 'false' || resolvedSubmit" 
              invalid-feedback="Required Field."
              valid-feedback="Looks Good!" 
              :required="resolved == 'true'" maxlength="600"/>
            <p>* This is to document any complex solutions so they can be easily implemented later</p>
          </mdb-col>
        </mdb-row>
        <!--<mdb-btn id="submitAddTicket" class='QuadrusButton' size="lg" v-on:click="submitTicket" :disabled="manageTicketID == ''">Submit</mdb-btn>-->

        <br>
        <div v-if="manageTicketID">
          <mdb-row class="d-flex align-items-center justify-content-center">
            <mdb-btn :diabled="!itcrNumber" v-on:click="viewITCRModal = true" color="outline-primary">Generate an ITCR from the support ticket</mdb-btn>
          </mdb-row>
          <hr>
          <br><br>
        </div>

        <mdb-row class="d-flex justify-content-center">
          <mdb-btn class="mt-4 QuadrusButton" type="submit" v-on:click="submitTicket" v-if="!submitProcessing" :disabled="manageTicketID == '' || resolvedSubmit">Submit</mdb-btn>
          <mdb-btn class="mt-4 QuadrusButton" v-if="submitProcessing">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Processing...
          </mdb-btn>
        </mdb-row>
        <mdb-btn id="clearTicket" color="danger" v-on:click="clearTicketForm" :disabled="manageTicketID == '' || resolvedSubmit">Clear</mdb-btn>
      </form>
    </mdb-card-body>
    </mdb-card>

    <mdb-modal size="xl" centered :show="viewITCRModal" @close="viewITCRModal = false, requiredFields = false">
      <mdb-modal-header>
        <mdb-modal-title><p class="h2">Create ITCR</p></mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="requiredFields" @closeAlert="requiredFields=false" dismiss>
          Missing Required Fields
        </mdb-alert>
                  
        <form @submit.prevent="" class="was-validated">
          <mdb-col>
            <mdb-input label="Name of Submitter" v-model="nameSubmit" required readOnly/>
          </mdb-col>
          <mdb-col>
            <mdb-input label="Description" v-model="description" type='textarea' :rows="4" outline readOnly />
          </mdb-col>

          <mdb-col>
            <mdb-select label="Type" @getValue="setType" v-model="itcrTypeOptions"/>
          </mdb-col>
          <mdb-col>
            <div v-if="!itcrType" class="invalid-feedback d-block">Please select an option.</div>
            <div v-else class="valid-feedback d-block">Looks Good!</div>
          </mdb-col>

          <mdb-col>
            <mdb-input type="textarea" :rows="6" outline class="mb-3" v-model="additionalNotesITCR" label="Additional Notes" placeholder="Notes" maxlength="5000" />
          </mdb-col>
        </form>
      </mdb-modal-body>
      <mdb-modal-footer class="d-flex justify-content-between">	
        <mdb-btn color="secondary" @click.native="viewITCRModal = false, requiredFields = false">Close</mdb-btn>
        <mdb-btn v-on:click="generateITCR" class="QuadrusButton">Submit ITCR</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>


    <mdb-modal size="xl" centered :show="viewModal" @close="viewModal = false">
      <mdb-modal-header>
        <mdb-modal-title><p class="h2">Images Submitted by User</p></mdb-modal-title>
      </mdb-modal-header>
        <mdb-row class="container-fluid justify-content-center m-0">
                
        <mdb-col col="10 carousel-contain d-none d-md-block m-0">
          <mdb-carousel class="carousel" style="background-color: #000000" :items="basicCarousel" indicators controlls></mdb-carousel>
        </mdb-col>
      
      </mdb-row>
      <mdb-modal-footer class="d-flex justify-content-center">	
        <mdb-btn color="secondary" @click.native="viewModal = false">Close</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>

    <mdb-modal size="xl" :show="showDocsModal" @close="showDocsModal = false">
      <mdb-modal-header>
        <mdb-modal-title>Documents</mdb-modal-title>
      </mdb-modal-header>

      <mdb-modal-body>
        <div v-for="(doc, index) in documentsForTicket" :key="index" class="d-flex justify-content-between align-items-center mb-2">
          <span>{{ doc.name }}</span>
          <mdb-btn @click="downloadFile(doc.src)">Download</mdb-btn>
        </div>
      </mdb-modal-body>
      <mdb-modal-footer class="d-flex justify-content-center">
        <mdb-btn color="secondary" @click="showDocsModal = false">Close</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>


    <mdb-card class="mb-3 d-flex">
      <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">Assigned Support Tickets</h3>
      <mdb-card-body>
        <mdb-input class="mb-0 mt-2" type="checkbox" id="showResolved" name="showResolved" v-model="showResolved" label="Show Resolved"/>
        <QDataTable v-if="!showResolved" id='ticketTable' :rowData="this.ticketData.assigned.rowData" :filterWords="this.ticketData.assigned.filterWords" :headers="this.ticketData.assigned.columns" 
        :btnName="'Manage'" :hasBtn="true" @use-method='manageTicket' :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}">
        </QDataTable>
        <QDataTable v-if="showResolved" id='ticketTable2' :rowData="this.ticketData.closed.rowData" :filterWords="this.ticketData.closed.filterWords" :headers="this.ticketData.closed.columns" 
        :btnName="'View'" :hasBtn="true" @use-method='manageTicket' :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}">
        </QDataTable>
        <div :class="{'hideSpinner': isSetUp}" class="p-4">
          <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
        </div>
      </mdb-card-body>
    </mdb-card>
  </mdb-container>
</div>
</template>
<style>
  div i {
    padding-right: 1.5rem;
  }
  .textarea-scroll > textarea {
  height: 200px !important;
  max-height: 200px !important;
  overflow-y: auto !important;
  resize: none !important;
}
</style>
<script>
import Vue from 'vue'
import { mdbInput, mdbCard, mdbCarousel, mdbCardBody, mdbContainer, mdbBtn, mdbSelect, mdbRow, mdbCol, mdbDatePicker2, mdbFormInline, mdbIcon, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbAlert } from 'mdbvue';
import QDataTable from '@/components/QDataTable.vue';
import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
import * as sendEmail from '@/assets/js/email.js';
import JsonCSV from 'vue-json-csv';
import { formatDate } from '@/assets/js/formatDate.js';
import * as sanitizeInput from '@/assets/js/sanitizeInput.js';

Vue.component('downloadCsv', JsonCSV)

export default {
	name: 'IT-Tickets',
	components: {
    mdbInput,
    mdbCard,
    mdbCardBody,
    mdbContainer,
    mdbBtn,
    mdbSelect,
    QDataTable,
    mdbRow,
    mdbCol,
    mdbDatePicker2,
    mdbFormInline,
    mdbIcon,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbAlert,
    mdbCarousel
    },
    
    data() {
      return {
        isSetUp: false,
        ticketHasImage: false,
        ticketHasDocs: false,
        p1: false,
        p2: false,
        p3: false,
        p4: false,
        p5: false,
        p7: false,
        p8: false,
        reqTicketFields: false,
        requiredFields: false,
        viewModal: false,
        basicCarousel: [],
        documentsForTicket: [],
        showDocsModal: false,
        viewReport: false,
        viewITCRModal: false,

        resolvedSubmit: false,

        resolvedSort: false,
        unassignedSort: false,
        assignedSort: false,

      additionalNotesITCR: "",
      itcrType: "",
      itcrTypeOptions: [{text: "System", value: "System"},{text: "Facility", value: "Facility"}],

        scopeYear: 0,
        scopeMonth: 0,
        monthOptions: [
            { text: 'None', value: '0', selected: true },
            { text: 'January', value: '1', selected: false },
            { text: 'February', value: '2', selected: false },
            { text: 'March', value: '3', selected: false },
            { text: 'April', value: '4', selected: false },
            { text: 'May', value: '5', selected: false },
            { text: 'June', value: '6', selected: false },
            { text: 'July', value: '7', selected: false },
            { text: 'August', value: '8', selected: false },
            { text: 'September', value: '9', selected: false },
            { text: 'October', value: '10', selected: false },
            { text: 'November', value: '11', selected: false },
            { text: 'December', value: '12', selected: false }
        ],

        assignToOld: false,
        assignToIsSelf: false,
        userAssignedName: '',     
        
        issue: '',
        imagesOfIssue: [],
        description: '',
        subject: "",
        priority: '3',
        dateOpened: '',
        dateClosed: '',
        nameSubmit: '',
        emailSubmit: '',
        assignTo: null,
        userAssigned: '',
        resolved: 'false',
        solution: '',
        additionalNotes: '',
        submitProcessing: false,
        dateOpenedDisplay: '',
        dateClosedDisplay: '',
        itusers: [],
        itcrNumber: '',

        subjectOptions: [
          { text: "Hardware", value: "Hardware" },
          { text: "Software", value: "Software" },
          { text: "Infrastructure", value: "Infrastructure" },
          { text: "Networking", value: "Networking" },
          { text: "Other", value: "Other" }
        ],

        assignToOptions: [],

        priorityModal: false,
        showResolved: false,
        manageTicketID: '',

          // Ticket Table
        ticketData: {
          unassigned: {
            columns: [
              {
                colTitle: 'Ticket Number',
                sortBy: 'id'
              },
              {
                colTitle: 'Date Opened',
                sortBy: 'openDateDisplay'
              },
              {
                colTitle: 'Description',
                sortBy: 'description'
              },
              {
                colTitle: 'Name of Submitter',
                sortBy: 'nameSubmit'
              },
              {
                colTitle: 'Email of Submitter',
                sortBy: 'emailSubmit'
              },
              {
                colTitle: 'Action',
                sortBy: ''
            }
            ],
            rowData: [],
            filterWords: [
              'id',
              'openDateDisplay',
              'description',
              'nameSubmit',
              'emailSubmit'
            ]
          },
          assigned: {
            columns: [  
              {
                colTitle: 'Ticket Number',
                sortBy: 'id'
              },
              {
                colTitle: 'Subject',
                sortBy: 'subject'
              },
              {
                colTitle: 'Date Opened',
                sortBy: 'openDateDisplay'
              },
              {
                colTitle: 'Priority',
                sortBy: 'priority'
              },
              {
                colTitle: 'Assigned To',
                sortBy: 'assignedTo'
              },
              {
                colTitle: 'Description',
                sortBy: 'description'
              },
              {
                colTitle: 'Action',
                sortBy: ''
              }
            ],
            rowData: [],
            filterWords: [
              'id',
              'subject',
              'openDateDisplay',
              'priority',
              'assignedTo',
              'description'
            ]
          },
          closed: {
            columns: [  
              {
                colTitle: 'Ticket Number',
                sortBy: 'id'
              },
              {
                colTitle: 'Date Opened',
                sortBy: 'openDateDisplay'
              },
              {
                colTitle: 'Date Closed',
                sortBy: 'closeDateDisplay'
              },
              {
                colTitle: 'Subject',
                sortBy: 'subject'
              },
              {
                colTitle: 'Description',
                sortBy: 'description'
              },
              {
                colTitle: 'Solution',
                sortBy: 'solution'
              },
              {
                colTitle: 'Action',
                sortBy: ''
              }
            ],
            rowData: [],
            filterWords: [
              'id',
              'openDateDisplay',
              'closeDateDisplay',
              'subject',
              'description',
              'solution'
            ]
          }
        }
      }
    },

    methods: {

      clearTicketForm: function() {
        this.description = "";
        this.priority = '3';
        this.dateOpened = "";
        this.dateClosed = "";
        this.nameSubmit = "";
        this.emailSubmit = "";
        this.solution = "";
        this.additionalNotes = "";
        this.issue = "";
        this.imagesOfIssue = [];
        this.ticketHasDocs = false;
        this.ticketHasImage = false;
        this.dateOpenedDisplay = "";
        this.dateClosedDisplay = "";
        this.resolved = 'false';
        this.resolvedSubmit = false;
        this.manageTicketID = '';
        this.subject = '';
        this.assignTo = null;
        this.subjectOptions = [
          { text: "Hardware", value: "Hardware" },
          { text: "Software", value: "Software" },
          { text: "Infrastructure", value: "Infrastructure" },
          { text: "Networking", value: "Networking" },
          { text: "Other", value: "Other" }
        ]

      },

      handleToggle: function(type) {
        if (type === 'unassigned') {
          this.unassignedSort = this.unassignedSort ? false : true;
        } else if(type === 'assigned') {
          this.assignedSort = this.assignedSort ? false : true;
        } else if (type === 'resolved') {
          this.resolvedSort = this.resolvedSort ? false : true;
        }
      },

      setScopeMonth: function(value)
      {
        this.scopeMonth = parseInt(value);
      },

      setType: function(type) {
        this.itcrType = type;
      },


      loadFileData: function() {
        this.ticketHasDocs = false;
        this.ticketHasImage = false;
        this.basicCarousel.splice(0);
        this.documentsForTicket.splice(0);

        if(this.imagesOfIssue.data){ 
          for (let i = 0; i < this.imagesOfIssue.data.length; i = i + 1) {
            if(this.isImage(this.imagesOfIssue.data[i].attributes.url.split('.')[1])){
              this.ticketHasImage = true;
              this.basicCarousel.push({img: true, src: DatabaseLib.getEndpoint('strapiDatabase').slice(0, -1) + this.imagesOfIssue.data[i].attributes.url});
            } else {
              this.ticketHasDocs = true;
              this.documentsForTicket.push({name: this.imagesOfIssue.data[i].attributes.name, src: DatabaseLib.getEndpoint('strapiDatabase').slice(0, -1) + this.imagesOfIssue.data[i].attributes.url});
            }
          }
        }
      },
      isImage: function(type) {
        return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(type)
      },
      viewImages: function(){
        this.viewModal = true;
      },

      viewDocuments: function(){
        this.showDocsModal = true;
      },

      downloadFile: async function(url) {
        try {
          const response = await fetch(url)
          const blob = await response.blob()

          const blobUrl = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = blobUrl
          link.download = url.split('/').pop()

          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          window.URL.revokeObjectURL(blobUrl)
        } catch (error) {
          console.error('Download failed:', error)
        }
      },

      resetTicketTable: function() {
        this.ticketData.assigned.rowData.splice(0);
        this.ticketData.closed.rowData.splice(0);
      },

      resetUnassignedTicketTable: function() {
        this.ticketData.unassigned.rowData.splice(0);
      },

      setDate: function() {
        if(this.resolved == 'true'){
          this.dateClosedDisplay = formatDate(new Date().toISOString());
        } else {
          this.dateClosedDisplay = "";
        }
      },

      generateITCR: async function() {
        if(!this.itcrType){
          this.requiredFields = true;
          return;
        }

        this.additionalNotesITCR = sanitizeInput(this.additionalNotesITCR, this.$sanitize);
        this.description = sanitizeInput(this.description, this.$sanitize);
        this.itcrType = sanitizeInput(this.itcrType, this.$sanitize);
        this.submitter = sanitizeInput(this.nameSubmit, this.$sanitize);

        let token = this.$store.getters.getToken;
        let data = {
          data: {
            submitter: this.submitter,
            submitDate: new Date().toISOString(),
            changeDescription: this.description,
            additionalNotes: this.additionalNotesITCR,
            stage: "SIA",
            itcrType: this.itcrType,
            it_ticket: this.manageTicketID
          }
        }
        try {
          await DatabaseLib.postRequest('strapiDatabase','itcrs',token,data);
          this.p7 = true;
        } catch(error) {
          this.p8 = true;
        }
        this.viewITCRModal = false;
        window.scroll({top: 0, behavior: 'smooth'});
        this.itcrType = '';
      },

      populateSubject: function(subject) {
        this.subjectOptions.forEach(option => {
          if (subject === option.value)
          {
            option.selected = true;
          } else {
            option.selected = false;
          }
        });
      },

      populateAssignTo: async function(assignment) {
        let token = this.$store.getters.getToken;
        let query = "populate[0]=groups&populate[1]=role";
        let filter = [];
        this.assignToOptions.splice(0);
        this.itusers.splice(0);
      
        try {
          let res = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
          for(let v = 0; v < res.data.length; v = v + 1){
            for(let i = 0; i < res.data[v].groups.length; i = i + 1) {
              if(res.data[v].groups[i].name == "IT"){
                filter.push(res.data[v]);
              }
            }
          }
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p4 = true;
          return;
        }
        filter.forEach(selectData => {
          let obj = {};
          if(selectData.role.name != "Administrator"){
            obj["text"] = selectData.firstName + ' ' + selectData.lastName;
            obj["value"] = selectData.id;
            if(selectData.id == assignment){
              obj["selected"] = true;
            }
            this.assignToOptions.push(obj);
            this.itusers.push({id: selectData.id, name: selectData.firstName + ' ' + selectData.lastName, email: selectData.email, username: selectData.username})
          }
        });
      },

      manageUnassignedTicket: function(data) {
        this.clearTicketForm();
        this.populateAssignTo();
        this.description = data.description;
        this.dateOpened = data.openDate;
        this.dateOpenedDisplay = formatDate(data.openDate);
        this.nameSubmit = data.nameSubmit;
        this.emailSubmit = data.emailSubmit;
        this.manageTicketID = data.id;
        this.issue = data.issue;
        this.imagesOfIssue = data.imagesOfIssue;
        this.additionalNotes = data.additionalNotes;
        this.resolved = 'false';
        this.resolvedSubmit = false;
        this.itcrNumber = data.itcr;
        this.loadFileData();

        document.getElementById("ticketForm").scrollIntoView({behavior: "smooth"});
      },

      manageTicket: async function(data) {
        let token = this.$store.getters.getToken;
        let query = "filters[id][$eq][0]="+data.id + "&populate[1]=imagesOfIssue&populate[2]=itcr&populate[3]=userAssigned";
        this.manageTicketID = data.id;
        let response = '';
        try {
          response = await DatabaseLib.getRequest('strapiDatabase','it-tickets',token,query);
        } catch(error) {
          window.scroll({top: 0, behavior: 'smooth'});
          this.p5 = true;
          return;
        }

        this.description = response.data.data[0].attributes.description;
        this.subject = response.data.data[0].attributes.subject;
        this.issue = response.data.data[0].attributes.issue;
        this.priority = response.data.data[0].attributes.priority;
        this.dateOpened = response.data.data[0].attributes.openDate;
        this.dateClosed = response.data.data[0].attributes.closeDate;
        this.nameSubmit = response.data.data[0].attributes.nameSubmit;
        this.emailSubmit = response.data.data[0].attributes.emailSubmit;
        this.resolved = response.data.data[0].attributes.resolved ? 'true' : 'false';
        this.resolvedSubmit = response.data.data[0].attributes.resolved;
        this.solution = response.data.data[0].attributes.solution;
        this.imagesOfIssue = response.data.data[0].attributes.imagesOfIssue;  
        this.additionalNotes = response.data.data[0].attributes.additionalNotes;
        this.itcrNumber = response.data.data[0].attributes.itcr.data ? response.data.data[0].attributes.itcr.data.id : null;

        this.dateOpenedDisplay = formatDate(this.dateOpened);
        // user assignment
        
        this.userAssigned = response.data.data[0].attributes.userAssigned.data ? response.data.data[0].attributes.userAssigned.data : null;
        this.assignTo = this.userAssigned ? this.userAssigned.id : null;
        this.assignToOld = this.assignTo;
        this.userAssignedName = response.data.data[0].attributes.userAssigned.data.attributes.firstName + ' ' + response.data.data[0].attributes.userAssigned.data.attributes.lastName
        await this.populateAssignTo(this.assignTo);
        await this.populateSubject(this.subject);

        this.loadFileData();

        if(this.resolved == 'true') {
          document.getElementById('resolvedFalse').checked = false;
          document.getElementById('resolvedTrue').checked = true;
          this.dateClosedDisplay = await response.data.data[0].attributes.closeDate ? formatDate(response.data.data[0].attributes.closeDate): "";
        } else {
          document.getElementById('resolvedTrue').checked = false;
          document.getElementById('resolvedFalse').checked = true;
        }
    
        document.getElementById("ticketForm").scrollIntoView({behavior: "smooth"});
      },

      populateUnassignedTicketData: async function() {
        this.isSetUp = false;
        let token = this.$store.getters.getToken;
        var query = '';

        try {
          query = "filters[queued][$eq][0]="+false + "&populate[1]=imagesOfIssue&populate[2]=itcr";

          let response = '';
          response = await DatabaseLib.getRequest('strapiDatabase','it-tickets',token,query);
          
          this.resetUnassignedTicketTable();

          for(let i = 0; i < response.data.data.length; i = i + 1) {
            this.ticketData.unassigned.rowData.push({
              id: response.data.data[i].id,
              description: response.data.data[i].attributes.description,
              issue: response.data.data[i].attributes.issue,
              imagesOfIssue: response.data.data[i].attributes.imagesOfIssue,
              openDate: response.data.data[i].attributes.openDate,
              nameSubmit: response.data.data[i].attributes.nameSubmit,
              emailSubmit: response.data.data[i].attributes.emailSubmit,
              additionalNotes: response.data.data[i].attributes.additionalNotes,
              resolved: response.data.data[i].attributes.resolved ? "true": "false",
              resolvedSubmit: response.data.data[i].attributes.resolved,
              openDateDisplay: formatDate(response.data.data[i].attributes.openDate),
              itcr: response.data.data[i].attributes.itcr.data ? response.data.data[i].attributes.itcr.data.id : null
            })
          }
          this.populateAssignTo(null);
          this.isSetUp = true;
        } catch(error) {
          this.isSetUp = true;
          window.scroll({top: 0, behavior: 'smooth'});
          this.p3 = true;
          return;
        }
      },

      populateTicketData: async function() {
        this.isSetUp = false;
        let token = this.$store.getters.getToken;
        var query = '';

        try {
          query = "filters[queued][$eq][0]="+true + "&populate[1]=imagesOfIssue&populate[2]=itcr&populate[3]=userAssigned";
          this.resetTicketTable();
          let response = '';

          response = await DatabaseLib.getRequest('strapiDatabase','it-tickets',token,query);

          for(let i = 0; i < response.data.data.length; i = i + 1) {
            if(response.data.data[i].attributes.resolved == false) {     
              this.ticketData.assigned.rowData.push({
                id: response.data.data[i].id,
                subject: response.data.data[i].attributes.subject,
                openDate: response.data.data[i].attributes.openDate,
                priority: response.data.data[i].attributes.priority,
                resolved: response.data.data[i].attributes.resolved,
                assignedTo: response.data.data[i].attributes.userAssigned.data ? response.data.data[i].attributes.userAssigned.data.attributes.firstName + " " + response.data.data[i].attributes.userAssigned.data.attributes.lastName : null,
                description: response.data.data[i].attributes.description,
                issue: response.data.data[i].attributes.issue,
                imagesOfissue: response.data.data[i].attributes.imagesOfIssue,
                emailSubmit: response.data.data[i].attributes.emailSubmit,
                nameSubmit: response.data.data[i].attributes.nameSubmit,
                openDateDisplay: formatDate(response.data.data[i].attributes.openDate),
                itcr: response.data.data[i].attributes.itcr.data ? response.data.data[i].attributes.itcr.data.id : null
              }) 
            } else {
              this.ticketData.closed.rowData.push({
                id: response.data.data[i].id,
                subject: response.data.data[i].attributes.subject,
                openDate: response.data.data[i].attributes.openDate,
                priority: response.data.data[i].attributes.priority,
                resolved: response.data.data[i].attributes.resolved,
                assignedTo: response.data.data[i].attributes.userAssigned.data ? response.data.data[i].attributes.userAssigned.data.attributes.firstName + " " + response.data.data[i].attributes.userAssigned.data.attributes.lastName : null,
                description: response.data.data[i].attributes.description,
                issue: response.data.data[i].attributes.issue,
                imagesOfissue: response.data.data[i].attributes.imagesOfIssue,
                additionalNotes: response.data.data[i].attributes.additionalNotes,
                closeDate: response.data.data[i].attributes.closeDate,
                solution: response.data.data[i].attributes.solution,
                emailSubmit: response.data.data[i].attributes.emailSubmit,
                nameSubmit: response.data.data[i].attributes.nameSubmit,
                openDateDisplay: formatDate(response.data.data[i].attributes.openDate),
                closeDateDisplay: response.data.data[i].attributes.closeDate ? formatDate(response.data.data[i].attributes.closeDate): "",
                itcr: response.data.data[i].attributes.itcr.data ? response.data.data[i].attributes.itcr.data.id : null
              })
            }
          }
          this.isSetUp = true;
        } catch(error) {
          this.isSetUp = true;
          window.scroll({top: 0, behavior: 'smooth'});
          this.p3 = true;
          return;
        }
      },

    setSubject: function(value) {
      this.subject = value;
    },

    setAssignTo: function(value) {
      this.assignTo = value;
    },

    submitTicket: async function () {
      this.submitProcessing = true;

      if((this.resolved == 'true' && this.solution == '') || this.priority == '') {
        this.submitProcessing = false;
        document.getElementById("ticketForm").scrollIntoView({behavior: "smooth"});
        this.reqTicketFields = true;
        return;
      }
      const token = this.$store.getters.getToken;

      // --- Sanitize Inputs ---
      const fieldsToSanitize = [
        "subject", "userAssigned", 
        "priority", "additionalNotes", "solution"
      ];
      fieldsToSanitize.forEach(f => this[f] = sanitizeInput(this[f], this.$sanitize));

      const utcTimestamp = new Date().toISOString();
      if (this.resolved == 'true') {
        this.dateClosed = utcTimestamp;
      }

      // --- Build Ticket Payload ---
      const data = {
        data: {
          description: this.description,
          issue: this.issue,
          subject: this.subject,
          priority: this.priority,
          openDate: this.dateOpened,
          closeDate: this.dateClosed ? this.dateClosed : null,
          nameSubmit: this.nameSubmit,
          emailSubmit: this.emailSubmit,
          userAssigned: this.assignTo,
          resolved: this.resolved == 'true' ? true : false,
          solution: this.resolved == 'true' ? this.solution: "",
          queued: !!this.assignTo || this.resolved,
          additionalNotes: this.additionalNotes
        }
      };

      try {
        await DatabaseLib.putRequest(
          'strapiDatabase', 
          'it-tickets', 
          token, 
          this.manageTicketID, 
          data
        );
      } catch (error) {
        window.scroll({ top: 0, behavior: "smooth" });
        this.p2 = true;
        this.submitProcessing = false;
        return;
      }

      await this.notifyUsers();

      window.scroll({ top: 0, behavior: "smooth" });
      this.p1 = true;

      this.clearTicketForm();
      await Promise.all([
        this.populateTicketData(),
        this.populateUnassignedTicketData()
      ]);

      this.manageTicketID = "";
      this.submitProcessing = false;
    },

    // ----------------------------------------------------------
    // NOTIFY USERS
    // ----------------------------------------------------------

    notifyUsers: async function () {
      const token = this.$store.getters.getToken;
      this.assignToIsSelf = false;

      if (!this.assignTo && this.resolved == 'false') {
        return;
      }

      try {
        const index = this.itusers.findIndex(u => u.id === this.assignTo);
        if(JSON.parse(this.$store.getters.getId) === this.assignTo) {
          this.assignToIsSelf = true;
        }

        // Fetch ticket with notifications populated
        const query = `filters[id][$in][0]=${this.manageTicketID}&populate[1]=notifications`;
        const response = await DatabaseLib.getRequest(
          'strapiDatabase',
          'it-tickets',
          token,
          query,
          false
        );

        let notifications = response.data.data[0].attributes.notifications.data;
        let hasNotified = [];
        if(index >= 0){
          hasNotified = notifications.filter(n => n.attributes.username === this.itusers[index].username);
        }
        
        if(hasNotified.length <= 0 && !this.assignToIsSelf) {
            let data = {
              data: {
                username: index >= 0 ? this.itusers[index].username : "",
                userEmail: index >= 0 ? this.itusers[index].email : "",
                details: `Support Ticket #${this.manageTicketID} ${this.issue} has been assigned to you.`,
                type: "Manage Ticket",
                closeOnClick: false,
                notified: false,
              }
            }
            this.addNotification(data, token, notifications);
          }

        // --- PROCESS NOTIFICATIONS ---
        for (const note of notifications) {
          const { id, attributes } = note;
          const isSubmitter = attributes.userEmail === this.emailSubmit;
          const isAssignedUser = 
            index >= 0 && 
            this.itusers[index].username === attributes.username;

          if (this.resolved == 'true') {
            // Ticket closed → notify submitter, remove others
            if (isSubmitter) {
              await this.updateNotification(id, `Support Ticket #${this.manageTicketID} ${this.issue} has been closed.`, true, token);
            } else {
              await this.removeNotification(id, token);
            }
          } 
          else if (this.assignTo != this.assignToOld) {
            // Ticket assigned → notify assigned user + submitter
            if ((isAssignedUser && !this.assignToIsSelf) || isSubmitter) {
              await this.updateNotification(
                id,
                `Support Ticket #${this.manageTicketID} ${this.issue}: Assigned to ${this.itusers[index].name}`,
                false,
                token
              );
            } else {
              await this.removeNotification(id, token, this.itusers[index].name);
            }
          }
          // else: leave notifications alone (ticket unchanged)
        }

        this.bus.$emit("fireMethod");

        // --- EMAIL LOGIC ---
        await this.sendAssignmentEmails(index, token);

      } catch (error) {
        console.log(error);
      }
    },

    // ----------------------------------------------------------
    // HELPERS
    // ----------------------------------------------------------

    updateNotification: async function (id, details, closeOnClick, token) {
      return DatabaseLib.putRequest(
        "strapiDatabase",
        "notifications",
        token,
        id,
        { data: { details: details, closeOnClick: closeOnClick } }
      );
    },

    removeNotification: async function (id, token) {
      return DatabaseLib.deleteRequest("strapiDatabase", "notifications", token, id);
    },
    addNotification: async function (data, token, notifications) {
      let response = await DatabaseLib.postRequest("strapiDatabase","notifications",token,data);
      let notificationIDs = notifications.map(n => n.id);

      let notificationId = response.data.data.id;
      let notification = {
        data: {
          notifications: notificationIDs.concat([notificationId]),
        }
      };
      await DatabaseLib.putRequest('strapiDatabase','it-tickets',token,this.manageTicketID,notification);
    },

    sendAssignmentEmails: async function (assignedIndex, token, name) {
      // Assigned ticket
      if (this.resolved == 'false' && this.assignTo != this.assignToOld) {
        if (assignedIndex >= 0 && this.assignToIsSelf == false) {
          const assignedUser = this.itusers[assignedIndex];
          await sendEmail(
            assignedUser.email,
            "Support Ticket Assignment",
            `Support Ticket #${this.manageTicketID} has been assigned to you.<br>Name: ${this.nameSubmit}<br>Issue: ${this.issue}<br>Description: ${this.description}`,
            token,
            "SupportTicket&id=" + this.manageTicketID,
            []
          );
        }

        await sendEmail(
          this.emailSubmit,
          "Support Ticket Assigned",
          `Support Ticket #${this.manageTicketID} has been assigned to ${name}.<br>Issue: ${this.issue}<br>Description: ${this.description}`,
          token,
          "TicketStatus",
          []
        );
      }

      // Closed ticket
      else if (this.resolved == 'true') {
        await sendEmail(
          this.emailSubmit,
          "Support Ticket Closed",
          `Support Ticket #${this.manageTicketID} has been closed.<br>Issue: ${this.issue}<br>Description: ${this.description}`,
          token,
          "TicketStatus",
          []
        );
      }
    },

    checkPage: async function(){
      const id = this.$route.query.id;            
      if (id) {
        let data = {
          id: id
        }
        this.manageTicket(data);
      }
    },

  },
  computed: {
    exportData() {
      const combined = []
      const seenIds = new Set()
      let monthSet = this.scopeMonth != 0 ? true : false;
      let yearSet = this.scopeYear != 0 ? true : false;
      let gte = '';
      let lt = '';

      let endMonth = parseInt(this.scopeMonth)+1;
      let endYear = parseInt(this.scopeYear);
      if (endMonth == 13)
      {
        endMonth = 1;
        endYear = parseInt(this.scopeYear) + 1;
      }
      if(monthSet && yearSet){
        gte = this.scopeYear+'-'+('0'+this.scopeMonth).slice(-2)+'-01';
        lt = endYear +'-'+('0' + (endMonth)).slice(-2) + '-01';
      } else if(yearSet && !monthSet){
        gte = this.scopeYear+'-01-01';
        lt = (endYear+1) +'-01-01';
      }

      

      const addRows = (rows) => {
        rows.forEach(newObj => {
          if (!seenIds.has(newObj.id)) {
            seenIds.add(newObj.id)

            if(((monthSet || yearSet) && newObj.openDate >= gte && newObj.openDate <= lt) || (!monthSet && !yearSet)){
              combined.push({
                'Ticket Number': newObj.id || '',
                'Date Opened': newObj.openDate || '',
                'Date Closed': newObj.closeDate || '',
                'Subject': newObj.subject || '',
                'Description': newObj.description || '',
                'Solution': newObj.solution || '',
                'Resolved': newObj.resolved || false,
                'Submitter': newObj.nameSubmit || '',
                'Submitter Email': newObj.emailSubmit || '',
                'Priority': newObj.priority || '',
                'Assigned To': newObj.assignedTo || '',
              })
            }
          }
        })
      }

      if (this.unassignedSort) {
        addRows(this.ticketData.unassigned.rowData)
      }

      if (this.assignedSort) {
        addRows(this.ticketData.assigned.rowData)
      }

      if (this.resolvedSort) {
        addRows(this.ticketData.closed.rowData)
      }
      return combined;
    },
  },

  watch: {
    showResolved: function() {
      this.populateTicketData();
    }

  },    

  mounted() {
    this.populateUnassignedTicketData();
    this.populateTicketData();
    this.checkPage();
  }
}
</script>